import styles from '../../../../styles/incidents.module.css';
import { useForm } from 'react-hook-form';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { useIncidentFollowupUpsert } from '../../../../new/query';
import useMessageStore from '../../../../stores/message-store';
import React from 'react';
import IncidentErrorAlert from './incidenterroralert';
import { normalizeIncidentFollowupPayload } from './incident-payload';

const IncidentFollowupNew = ({values = null,incidentid,medicaidid,hashkey,onCreated}) => {
    const initalValues = {
        axisI: '',
        axisII: '',
        axisIII: '',
        recentMedicalConcerns: '',
        rightsRestrictionsList: '',
        rightsRestrictions: '',
        behaviorSupportPlan: '',
        crisisPlan: '',
        whyDidIncidentOccur: '',
        howCouldIncidentHaveBeenPrevented: '',
        staffTrainingNeeds: '',
        changesToSupportPlan: '',
        individualsCurrentState: '',
        howManyTimes_Individual: 0,
        whatDidYouDoToKeepThePersonSafeAndWell_Individual: '',
        whatChangesWillOccur_Individual: '',
        whenWillTheTeamMeetToConsiderChanges_Individual: '',
        howShouldTheseChangesBeImplemented_Individual: '',
        whenShouldTheseChangesBeImplemented_Individual: '',
        whoShouldEnsureChangesAreImplemented_Individual: '',
        concerns_Individual: '',
        howAreTheyDoing_Individual: '',
        howManyTimes_Agency: 0,
        systemsPoliciesFailed_Agency: '',
        systemsPoliciesNotWork_Agency: '',
        systemPoliciesChanges_Agency: '',
        whenSystemPoliciesChanges_Agency: '',
        whoWillMonitorChanges_Agency: '',
        dateIncidentFollowupReportCompleted: '',
        initialFollowupMissingAndMFPStaffWillRespond: false
    }
    const individualIssues = [
        {
            title: 'How many times has this kind of incident happened with this individual in the past three months?',
            name: 'howManyTimes_Individual',
            type: 'number'
        },
        {
            title: 'What did you do to keep the person safe and well?',
            name: 'whatDidYouDoToKeepThePersonSafeAndWell_Individual',
            type: 'textarea'
        },
        {
            title: 'What changes will occur in the individual\'s life to prevent the incident from recurring and how will they be documented?',
            name: 'whatChangesWillOccur_Individual',
            type: 'textarea'
        },
        {
            title: 'When will the individual\'s team meet to consider these changes?',
            name: 'whenWillTheTeamMeetToConsiderChanges_Individual',
            type: 'textarea'
        },
        {
            title: 'How should these changes be implemented?',
            name: 'howShouldTheseChangesBeImplemented_Individual',
            type: 'textarea'
        },
        {
            title: 'When would these changes be implemented?',
            name: 'whenShouldTheseChangesBeImplemented_Individual',
            type: 'textarea'
        },
        {
            title: 'Who should ensure these changes are implemented and followed?',
            name: 'whoShouldEnsureChangesAreImplemented_Individual',
            type: 'textarea'
        },
        {
            title: 'What concerns did the individual express when you talked with them about this incident?',
            name: 'concerns_Individual',
            type: 'textarea'
        },
        {
            title: 'How does the individual report they are doing today?',
            name: 'howAreTheyDoing_Individual',
            type: 'textarea'
        }
    ]

    const systemIssues = [
        {
            title: 'How many times has this kind of incident happened in your agency in the past three months?',
            name: 'howManyTimes_Agency',
            type: 'number'
        },
        {
            title: 'What system(s) or policy(ies) failed to prevent this incident from occuring or contributed to the incident occuring?',
            name: 'systemsPoliciesFailed_Agency',
            type: 'textarea'
        },
        {
            title: 'Why did this(these) system(s) or policy(ies) not work as was intended?',
            name: 'systemsPoliciesNotWork_Agency',
            type: 'textarea'
        },
        {
            title: 'How will the system(s) or policy(ies) be changed to prevent recurrence?',
            name: 'systemPoliciesChanges_Agency',
            type: 'textarea'
        },
        {
            title: 'When will the system(s) or policy(ies) be changed?',
            name: 'whenSystemPoliciesChanges_Agency',
            type: 'textarea'
        },
        {
            title: 'Who will monitor the system changes to ensure they are implemented and followed?',
            name: 'whoWillMonitorChanges_Agency',
            type: 'textarea'
        }
    ]

    const addToast = useMessageStore(state => state.addToast);

    const _GetFormReset = (data) => {
        return {
            ...data,
            rightsRestrictions: data.rightsRestrictions === null ? '' : data.rightsRestrictions ? 'yes' : 'no',
            behaviorSupportPlan: data.behaviorSupportPlan === null ? '' : data.behaviorSupportPlan ? 'yes' : 'no',
            crisisPlan: data.crisisPlan === null ? '' : data.crisisPlan ? 'yes' : 'no',
        }
    }

    const submittedCallback = (data) => {
        if(values === null){
            onCreated();
        }
        else{
            const {followup} = data; //Omit parts we do not need
            
            const resetVal = _GetFormReset(followup);
            reset(resetVal);
        } 

        addToast(
            {
                id: Math.random(),
                body: "The Followup was succesfully saved!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    }

    const mutation = useIncidentFollowupUpsert(incidentid,medicaidid,submittedCallback);

    const _submitFN = (data) => {
        mutation.mutate(normalizeIncidentFollowupPayload(data, incidentid));
    }

    const {register,reset,handleSubmit, formState: {isDirty}} = useForm({defaultValues: values === null ? initalValues: _GetFormReset(values)});
    return(
        <form onSubmit={handleSubmit(_submitFN)}>
            <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                <Row>
                    <Col xs={12} md={6}>
                        <fieldset>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Diagnoses</legend>
                            <div className={styles.inputGroup}>
                                <input type='text'placeholder='AXIS I' style={{width: '100%'}} {...register('axisI')} />
                                <input type='text'placeholder='AXIS II' style={{width: '100%'}} {...register('axisII')} />
                                <input type='text'placeholder='AXIS III' style={{width: '100%'}} {...register('axisIII')} />
                            </div>
                        </fieldset>
                        <strong>Does the Individual Have?</strong>
                        <fieldset>
                            <legend style={{fontSize: '1rem',marginBottom: '0'}}>Rights Restrictions</legend>
                                <div>
                                    <label>
                                        <input type='radio'  value='yes' {...register('rightsRestrictions')}/> Yes
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type='radio' value='no' {...register('rightsRestrictions')} /> No
                                    </label>
                                </div>
                        </fieldset>
                        <fieldset>
                            <legend style={{fontSize: '1rem',marginBottom: '0'}}>Behavioral Support Plan</legend>
                                <div>
                                    <label>
                                        <input type='radio' {...register('behaviorSupportPlan')} value='yes' /> Yes
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type='radio' {...register('behaviorSupportPlan')} value='no' /> No
                                    </label>
                                </div>
                        </fieldset>
                        <fieldset>
                            <legend style={{fontSize: '1rem',marginBottom: '0'}}>Crisis Plan</legend>
                                <div>
                                    <label>
                                        <input type='radio' {...register('crisisPlan')} value='yes' /> Yes
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type='radio' {...register('crisisPlan')} value='no' /> No
                                    </label>
                                </div>
                        </fieldset>
                    </Col>
                    <Col xs={12} md={6}>
                        <label htmlFor='medconcerns'>Recent Medical Concerns</label>
                        <textarea id='medconcerns' style={{width: '100%'}}  rows={6} {...register('recentMedicalConcerns')}/>
                        <label htmlFor='rightsrestother'>Please list Rights Restrictions</label>
                        <textarea id='rightsrestother' style={{width: '100%'}}  rows={6} {...register('rightsRestrictionsList')} />
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs={12}>
                        <label htmlFor='why'>Why did this incident occur? (analysis of cause not restatement of information on initial report)</label>
                        <textarea id='why' style={{width: '100%'}} rows={6} {...register('whyDidIncidentOccur')} />
                    </Col>
                    <Col xs={12}>
                        <label htmlFor='howprevent'>How could this have been prevented?</label>
                        <textarea id='howprevent' style={{width: '100%'}} rows={6} {...register('howCouldIncidentHaveBeenPrevented')}/>
                    </Col>
                    <Col xs={12}>
                        <label htmlFor='stafftraining'>What staff training needs were identified?</label>
                        <textarea id='stafftraining' style={{width: '100%'}} rows={6} {...register('staffTrainingNeeds')}/>
                    </Col>
                    <Col xs={12}>
                        <label htmlFor='supportplanchanges'>Are any changes needed to the individual support plan?</label>
                        <textarea id='supportplanchanges' style={{width: '100%'}} rows={6} {...register('changesToSupportPlan')}/>
                    </Col>
                    <Col xs={12}>
                        <label htmlFor='currentstatus'>What is the individuals current status?</label>
                        <textarea id='currentstatus' style={{width: '100%'}} rows={6} {...register('individualsCurrentState')}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <fieldset className={`${styles.twoCol} ${styles.dividedCol}`}>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Individual Issues</legend>
                            {
                                individualIssues.map((item) => (
                                    <React.Fragment key={item.name}>
                                        <label  htmlFor={item.name}>{item.title}</label>
                                        {
                                            item.type === 'textarea' &&
                                            <textarea id={item.name} style={{width: '100%'}} rows={4} {...register(item.name)} />

                                        }
                                        {
                                            item.type === 'number' &&
                                            <div >
                                                <input id={item.name} type='number' min={0}  {...register(item.name,{valueAsNumber: true})}/>
                                            </div>                                    
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </fieldset>
                    </Col>
                    <Col xs={12} md={6}>
                        <fieldset className={styles.dividedCol}>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>System Issues</legend>
                            {
                                systemIssues.map((item) => (
                                    <React.Fragment key={item.name}>
                                    <label htmlFor={item.name}>{item.title}</label>
                                    {
                                        item.type === 'textarea' &&
                                        <textarea  id={item.name} style={{width: '100%'}} rows={6} {...register(item.name)} />
                                    }
                                    {
                                        item.type === 'number' &&
                                        <div>
                                            <input  id={item.name} type='number' min={0} {...register(item.name,{valueAsNumber: true})} />
                                        </div>  
                                    }
                                    </React.Fragment>
                                ))
                            }
                        </fieldset>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <label htmlFor='dateIncidentFollowupReportCompleted'>Date Incident Report Followup Completed</label> <br/>
                        <input id='dateIncidentFollowupReportCompleted' type='date' {...register('dateIncidentFollowupReportCompleted')} /> <br />
                        <label>
                            <input type='checkbox' {...register('initialFollowupMissingAndMFPStaffWillRespond')} />
                            Initial Followup Missing And MFP Staff Will Respond
                        </label>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs={12}>
                        <IncidentErrorAlert
                            error={mutation.error}
                            fallbackMessage="The incident follow-up could not be saved."
                            className="mb-3"
                        />
                        <div className='d-flex justify-content-end'>
                            <Button type="submit" variant={values ? "primary" : 'success'} disabled={mutation.isPending || (values ? !isDirty : false)}>
                            {
                                mutation.isPending
                                ?
                                    <Spinner animation='border' size='sm' />
                                :
                                    values
                                    ?
                                        <>Save Changes</>
                                    :
                                        <>Add Followup</>
                            }
                        </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </form>
    )
}

export default IncidentFollowupNew;
